import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { Amplify } from 'aws-amplify';
import { datadogLogs } from '@datadog/browser-logs'
import * as serviceWorker from './serviceWorker';
import './styles/index.css';
import amplifyConfig from './amplifyconfig.js';
import datadogConfig from './datadogconfig.js';
import { defaultStorage } from 'aws-amplify/utils';
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito';
import { StoreProvider } from './context/StoreContext';
import { SmsProvider } from './context/SmsContext';
import { DatePickerProvider } from './utils/DatePickerProvider';
import { FeedbackProvider } from './context/FeedbackContext';
import { WorkOrderProvider } from './context/WorkOrderContext';
import { UserProvider } from './context/UserContext';

cognitoUserPoolsTokenProvider.setKeyValueStorage(defaultStorage);
Amplify.configure(amplifyConfig);
if(process.env.REACT_APP_DATADOG_CLIENT_TOKEN && process.env.REACT_APP_DATADOG_CLIENT_TOKEN !== 'REPLACE') {
  console.log('datadog enabled')
  datadogLogs.init(datadogConfig);
}

ReactDOM.render(
  <BrowserRouter>
    <DatePickerProvider>
      <FeedbackProvider>
        <StoreProvider>
          <UserProvider>
            <WorkOrderProvider>
              <SmsProvider>
                <App />
              </SmsProvider>
            </WorkOrderProvider>
          </UserProvider>
        </StoreProvider>
      </FeedbackProvider>
    </DatePickerProvider>
  </BrowserRouter>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
